// Spanish language configuration
// This file contains language-specific settings for Spanish

export default {
    label: 'Español',
    dateFormats: {
        LT: 'H:mm',
        LTS: 'DD/MM/YYYY H:mm',
        L: 'DD/MM/YYYY',
        LL: 'D [de] MMMM [de] YYYY',
        LLL: 'D [de] MMMM [de] YYYY H:mm',
        LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
    },
    thousandGroupStyle: 'thousand',
};
